<template>
    <div class="single-choice item-list" :class="{'inline': !config.vertical}">
        <draggable :list="items" :disabled="!editable" @change="onChange">
            <div v-for="(item, index) in items" :key="index" class="item tw-group/rank tw-mb-2" 
                 @click="selectOption(item)" :class="{'selected': item === selected}">
                <label class="choice" :style="{
                            ...inputStyles,
                            borderColor: inputStyles.color,
                            backgroundColor: convertHexToRGBA(inputStyles.color, 10)
                        }">
                    <span class="radio" :style="{ borderColor: inputStyles.color }"></span>
                    <survey-page-editable :target="item" :editable="editable" placeholder="Option" @changed="onEditableChange($event,index)" />
                </label>
                <span v-if="editable" class="remove tw-hidden group-hover/rank:tw-inline-block" @click="deleteChoice(index)"></span>
            </div>
        </draggable>

        <div class="item tw-group/rank tw-mb-2" v-if="config.other_option" @click="selectOption(custom)" :class="{'selected': custom === selected}">
            <label class="choice" :style="{
                            ...inputStyles,
                            borderColor: inputStyles.color,
                            backgroundColor: convertHexToRGBA(inputStyles.color, 10)
                        }">
                <span class="radio" :style="{ borderColor: inputStyles.color }"></span>
                <survey-page-editable :target="custom" :editable="true" :untouchable="editable" placeholder="Other" @changed="selectOption($event,true)" />
            </label>
        </div>
        
        <div v-if="editable" class="add-choice" :style="{color: inputStyles.color}" @click="addChoice">Add Choice</div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import SurveyPageEditable from "@/pages/surveys/SurveyPageEditable.vue";

export default {
    name: 'QuestionSingleChoice',
    components: {SurveyPageEditable, draggable},
    props: {
        value: {
            type: String,
            default: ''
        },
        inputStyles: {
            type: Object,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            items: [],
            selected: undefined,
            custom: '',
        }
    },
    computed: {
        shouldShowOther() {
            return this.config.other_option && this.selected === 'other'
        },
    },
    watch: {
        value: {
            immediate: true,
            handler: 'setSelected',
        },
        'config.options'() {
            this.resetOptions();
        },
    },
    methods: {
        selectOption(value, isCustom = false) {
            if (this.editable) return;
            if (isCustom) this.custom = value;
            this.selected = value;
            this.onChange();
        },
        setSelected() {
            if (this.config.options.includes(this.value)) {
                this.selected = this.value;
            }
            this.onChange();
        },
        onEditableChange(item,index) {
            this.items[index] = item;
            this.onChange();
        },
        onChange() {
            if (!this.readonly) this.$emit('answer', {value: this.selected, valid: true});
            if (this.editable) this.$emit('config', {options: this.items});
        },
        addChoice() {
            if (!this.editable) return;
            this.items.push('');
            this.$emit('config', {options: this.items});
        },
        deleteChoice(index) {
            this.items.splice(index,1);
            this.$emit('config', {options: this.items});
        },
        resetOptions() {
            this.items = this.config.options;
            if (!this.items) this.items = [];
        }
    },
    mounted() {
        this.resetOptions();
    }
}
</script>
